__turbopack_context__.v({
  "pause": "styles-module__7ND9ZW__pause",
  "play": "styles-module__7ND9ZW__play",
  "play-animation": "styles-module__7ND9ZW__play-animation",
});
